<template>
  <div id="document-detail">
    <path-component :paths="paths" />
    <b-container fluid>
      <b-row>
        <b-col>
          <h5 class="text-left">
            {{ title }}
          </h5>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col cols="12">
          <edit-invoice-component
            :document-id="documentDetail.id"
            :invoice-number="documentDetail.in"
            :date-invoice="documentDetail.created_date"
            :document-type-name="this.documentDetail.document_type_name"
          />
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col cols="12">
          <test-orders-table-component
            class="table-modal"
            :orders="this.documentDetail"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" class="p-0">
          <add-document-footer :data="this.documentDetail.test_list" />
        </b-col>
      </b-row>
      <b-row class="d-flex justify-content-center">
        <b-col
          v-for="document in getFilterDocumentType"
          :key="document.id"
          cols="1"
        >
          <b-button block class="printed-btn">
            พิมพ์{{ document.name }}
          </b-button>
        </b-col>
        <b-col cols="1">
          <b-button class="pdf-download-btn">
            ดาวน์โหลดเป็น PDF
          </b-button>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import PathComponent from "../../components/PathComponent";
import EditInvoiceComponent from "../../components/Account/EditInvoiceComponent";
import TestOrdersTableComponent from "../../components/Account/TestOrdersTableComponent";
import AddDocumentFooter from "../../components/Account/AddDocumentFooter";
import { mapGetters } from "vuex";

export default {
  name: "DocumentDetail",
  components: {
    PathComponent,
    EditInvoiceComponent,
    TestOrdersTableComponent,
    AddDocumentFooter,
  },
  computed: {
    ...mapGetters({
      corporation: "Account/getCorporationSelected",
      corporations: "Corporation/getAll",
      documentDetail: "Account/getDocumentDetail",
      getFilterDocumentType: "Account/getFilterDocumentType",
    }),
  },
  data() {
    return {
      paths: [],
      title: "แก้ไข",
    };
  },
  mounted() {
    this.title += this.documentDetail.document_type_name;
    this.paths = [
      {
        name: `ออกรายงาน ${this.corporation}`,
        path: "account",
        active: false,
      },
      {
        name: this.title,
        path: "account-document-detail",
        active: true,
      },
    ];
  },
  methods: {
    getCorporationName(id) {
      return this.corporations.find(function(corporation) {
        return id === corporation.id;
      }).name;
    },
  },
};
</script>

<style lang="scss" scoped>
.table-modal {
  max-height: 400px;
  overflow-y: auto;
}
.printed-btn {
  height: 100%;
}
.printed-btn {
  background-color: #fd881e;
  border: none;
  height: 100%;
}

.pdf-download-btn {
  background-color: #2e83d9;
  border: none;
  height: 100%;
}
</style>
